import React, { useState, useEffect } from 'react';
import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import LoaderGIF from "assets/img/loader/venuelog_loading.gif";

const LoaderContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  height: '100vh',
  width: '100vw',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  '&:after': {
    content: '""',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    display: 'block',
    backgroundColor: '#dddfe4',
    zIndex: -1,
    backdropFilter: 'blur(10px)',
  },
}));

const animations = {
  bounce: keyframes`
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-30px); }
    60% { transform: translateY(-15px); }
  `,
  pulse: keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  `,
  spin: keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `,
  fadeInOut: keyframes`
    0%, 100% { opacity: 0.2; }
    50% { opacity: 1; }
  `,
  slideIn: keyframes`
    0% { transform: translateX(-100%); }
    100% { transform: translateX(0); }
  `,
  zoomInOut: keyframes`
    0%, 100% { transform: scale(0.5); }
    50% { transform: scale(1.2); }
  `,
  shake: keyframes`
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
    20%, 40%, 60%, 80% { transform: translateX(10px); }
  `,
  flipHorizontal: keyframes`
    0%, 100% { transform: rotateY(0deg); }
    50% { transform: rotateY(180deg); }
  `,
  swingUpDown: keyframes`
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  `,
  circlePath: keyframes`
    0% { transform: rotate(0deg) translateX(50px) rotate(0deg); }
    100% { transform: rotate(360deg) translateX(50px) rotate(-360deg); }
  `,
};

const AnimatedLoader = styled('img')(({ animationType }) => ({
  width: '160px',
  animation: `${animations[animationType]} 2s infinite ease-in-out`,
}));

function APILoader() {
  const apiLoading = useSelector((state) => state.loader.loading);
  const [animationType, setAnimationType] = useState('bounce');

  useEffect(() => {
    const animationTypes = Object.keys(animations);
    const interval = setInterval(() => {
      setAnimationType((prevType) => {
        const currentIndex = animationTypes.indexOf(prevType);
        const nextIndex = (currentIndex + 1) % animationTypes.length;
        return animationTypes[nextIndex];
      });
    }, 5000); // Change animation every 5 seconds

    return () => clearInterval(interval);
  }, []);

  if (!apiLoading) return null;

  // if (apiLoading) return null;


  return (
    <LoaderContainer>
      <AnimatedLoader src={LoaderGIF} alt="loader" animationType={animationType} />
    </LoaderContainer>
  );
}

export default APILoader;